/* eslint-disable no-console */

import { DEV } from '../constants';

const warned = {};

export default function error(condition, format, ...args) {
    if (!DEV) return;
    if (!condition) return;

    let argumentIndex = 0;
    const message = format.replace(/%s/g, () => {
        const argument = args[argumentIndex];
        argumentIndex += 1;
        if (argument === undefined) return '%s';
        return argument.toString();
    });
    const argsRest = args.slice(argumentIndex);

    if (warned[message]) return;

    if (typeof console !== 'undefined' && console.error) {
        console.error(`Error: ${message}`, ...argsRest);
    }

    try {
        throw new Error(message);
    } catch (error_) {
        warned[message] = true;
    }
}
